import CompanyService from 'src/modules/company/companyService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';
import StockdataService from 'src/modules/company/stockdataService';

const prefix = 'COMPANY_FORM';

const companyFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  SEARCH_STARTED: `${prefix}_SEARCH_STARTED`,
  SEARCH_SUCCESS: `${prefix}_SEARCH_SUCCESS`,
  SEARCH_ERROR: `${prefix}_SEARCH_ERROR`,

  FUNDAMENTALS_STARTED: `${prefix}_FUNDAMENTALS_STARTED`,
  FUNDAMENTALS_SUCCESS: `${prefix}_FUNDAMENTALS_SUCCESS`,
  FUNDAMENTALS_ERROR: `${prefix}_FUNDAMENTALS_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: companyFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await CompanyService.find(id);
      }

      dispatch({
        type: companyFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: companyFormActions.INIT_ERROR,
      });

      getHistory().push('/company');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: companyFormActions.CREATE_STARTED,
      });

      await CompanyService.create(values);

      dispatch({
        type: companyFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.company.create.success'),
      );

      getHistory().push('/company');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: companyFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyFormActions.UPDATE_STARTED,
      });

      await CompanyService.update(id, values);

      dispatch({
        type: companyFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.company.update.success'),
      );

      getHistory().push('/company');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: companyFormActions.UPDATE_ERROR,
      });
    }
  },

  doSearch: (searchTerm) => async (dispatch) => {
    try {
      dispatch({
        type: companyFormActions.SEARCH_STARTED,
      });

      let record = {};

      record = await StockdataService.search(searchTerm);

      dispatch({
        type: companyFormActions.SEARCH_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: companyFormActions.SEARCH_ERROR,
      });
    }
  },

  doFundamentals: (identifier) => async (dispatch) => {
    try {
      dispatch({
        type: companyFormActions.FUNDAMENTALS_STARTED,
      });

      let record = {};

      record = await StockdataService.fundamentals(identifier);

      dispatch({
        type: companyFormActions.FUNDAMENTALS_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: companyFormActions.FUNDAMENTALS_ERROR,
      });
    }
  },
};

export default companyFormActions;
